import React from 'react';
import Icon from '../../../components/AppIcon';

const SuccessIndicator = () => {
  return (
    <div className="flex justify-center mb-8">
      <div className="relative">
        {/* Animated background circles */}
        <div className="absolute inset-0 flex items-center justify-center">
          <div className="w-24 h-24 bg-green-100 rounded-full animate-ping opacity-75"></div>
        </div>
        <div className="absolute inset-0 flex items-center justify-center">
          <div className="w-20 h-20 bg-green-200 rounded-full animate-pulse"></div>
        </div>
        
        {/* Checkmark icon */}
        <div className="relative w-24 h-24 bg-green-500 rounded-full flex items-center justify-center shadow-lg">
          <Icon name="Check" className="w-12 h-12 text-white" strokeWidth={3} />
        </div>
      </div>
    </div>
  );
};

export default SuccessIndicator;